import './index.css';
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext"; // <-- ADD THIS

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <AuthProvider>                 {/* <-- WRAP APP */}
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AuthProvider>
);
